/**
 *  [2022] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * reproduction of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

/**
 * :ZNOTE:
 * tag: localstorage,ローカルストレージ
 * note:
 *  - localstorageに情報を書き込んだり読み込んだりするためのユーティリティ
 * sample:
 *  -
 * :ZNOTE:
 */


let localStorage: any;
if (typeof window !== 'undefined') {
  localStorage = window.localStorage;
  if (typeof localStorage === 'undefined') { // for jest
    localStorage = global.localStorage;
  }
} else {
  if (typeof global.localStorage !== 'undefined') { // for jest
    localStorage = global.localStorage;
  } else {
    localStorage = () => {};
  }
}


let storageInfo: any;
const KEYNAME = 'appCacheStorage';

const loadStorage = () => {
  const storageInfoJSON = localStorage.getItem(KEYNAME);
  if (!storageInfoJSON) {
    storageInfo = {};
  } else {
    storageInfo = JSON.parse(storageInfoJSON);
  }
};

const updateStorageInfo = (tag: string, info: any) => {
  const path = location.href;
  if (!storageInfo) loadStorage();
  storageInfo[`${tag}:${path}`] = info;
  localStorage.setItem(KEYNAME, JSON.stringify(storageInfo));
};

const getStorageInfo = (tag: string): any => {
  const path = location.href;
  if (!storageInfo) loadStorage();
  return storageInfo[`${tag}:${path}`];
};


const flushStorageInfo = () => {
  localStorage.removeItem(KEYNAME);
};

const updateStorageValue = (tag: string, info: any) => {
  localStorage.setItem(tag, JSON.stringify(info));
};

const getStorageValue = (tag: string): any => JSON.parse(localStorage.getItem(tag));  // TODO: browserでも動くかどうか確認

const removeStorageInfo = (tag: string) => {
  localStorage.removeItem(tag);
};


export {getStorageInfo, updateStorageInfo, getStorageValue, updateStorageValue, flushStorageInfo, removeStorageInfo};
